const subOptionTitle = 'Service Type';

const subOptions = [
  {label: 'Ambulance Service', value: 'Ambulance Service'},
  {label: 'Australian Army', value: 'Australian Army'},
  {label: 'Fire and Rescue Service', value: 'Fire and Rescue Service'},
  {label: 'OS Defense Force', value: 'OS Defense Force'},
  {label: 'OS Emergency Services', value: 'OS Emergency Services'},
  {label: 'Police Service', value: 'Police Service'},
  {label: 'Royal Australian Air Force', value: 'Royal Australian Air Force'},
  {label: 'Royal Australian Navy', value: 'Royal Australian Navy'},
  {label: 'State Emergency Services', value: 'State Emergency Services'},
  {
    label: 'Emergency Service Volunteer\n(Ambulance, Fire, Police)',
    value: 'Emergency Service Volunteer',
  },
];

const primaryOptionTitle = 'Status';

const primaryOptions = [
  {label: 'Active Service Member', value: 'Active Service Member', subOptions},
  {label: 'Former Service Member', value: 'Former Service Member', subOptions},
  {label: 'Family Member', value: 'Family Member', subOptions: []},
  {label: 'Supporter', value: 'Supporter', subOptions: []},
];

export {subOptionTitle, primaryOptionTitle, primaryOptions, subOptions};
